import { inject, Injectable } from '@angular/core';
import { CanActivate, GuardResult, MaybeAsync } from '@angular/router';
import { AuthorizationService, Permissions } from '@rocksoft/shared/authorization';

@Injectable({
  providedIn: 'root',
})
export class CanAccessMdmSettingsGuard implements CanActivate {
  private readonly authorizationService = inject(AuthorizationService);

  canActivate(): MaybeAsync<GuardResult> {
    return this.authorizationService.getIsAuthorized$(Permissions.MdmSettingsRead);
  }
}
